"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useAuth0_1 = require("../hooks/useAuth0");
const AuthContainer = styled_components_1.default.span.attrs(props => ({
    id: "AuthContainer",
    className: props.className
})) `
   @media only screen and (max-width: 480px) {
      .auth0-lock.auth0-lock .auth0-loading-container .auth0-loading {
         top: -25vh;
         left: -13vw;
      }

      .auth0-lock-submit {
         position: absolute;
         top: 430.3px;
      }
   }

   .auth0-lock-submit {
      :hover {
         background-color: ${props => props.theme["hover-color"]} !important;
      }

      :active {
         background-color: ${props => props.theme["active-color"]} !important;
      }
   }
   & .auth0-lock.auth0-lock.auth0-lock {
      font-family: ${props => props.theme["font-family"]};
      & .auth0-lock-center {
         padding: 0;
      }
   }
`;
const getLockError = () => {
    const authError = document.location.hash;
    if (authError.trim() === "" || authError.trim() === "#") {
        return undefined;
    }
    const error = decodeURIComponent(authError
        .substring(authError.indexOf("error="), authError.indexOf("&", authError.indexOf("error=")))
        .split("=")[1]);
    const descr = decodeURIComponent(authError.substring(authError.indexOf("error_description=")).split("=")[1]);
    const errorText = error === "undefined"
        ? descr
        : descr === "undefined"
            ? error
            : `${error}: ${descr}`;
    const lockError = {
        flashMessage: {
            type: "error",
            text: errorText
        }
    };
    return lockError;
};
exports.Login = (props) => {
    const { lock } = useAuth0_1.useAuthContext();
    React.useLayoutEffect(() => {
        localStorage.clear();
        const lockError = getLockError();
        lock.show(lockError);
        return () => {
            lock.hide();
        };
    }, [lock]);
    return React.createElement(AuthContainer, null);
};
//# sourceMappingURL=Login.js.map